// frontend/src/contexts/AuthContext.js

import React, { createContext, useState } from 'react';
import { jwtDecode } from 'jwt-decode'; // Correct named import
import { setAuthHeaders } from '../api'; // Adjust the path if necessary
import api from '../api'; // Ensure this path is correct based on your project structure

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Synchronously initialize user state from localStorage
  const token = localStorage.getItem('jwtToken');
  let initialUser = null;
  const [pendingNavigation, setPendingNavigation] = useState(null);


  if (token) {
    try {
      const decoded = jwtDecode(token);

      initialUser = {
        id: decoded.id,
        email: decoded.email,
        name: decoded.name,
        tenantId: decoded.tenantId, // **STORE: tenantId**
        token: token,
      };
      setAuthHeaders(token, decoded.tenantId); // Set auth headers synchronously
    } catch (error) {
      console.error('AuthProvider: Invalid token during initialization:', error);
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('refreshToken');
    }
  } else {
    console.log('AuthProvider: No token found in localStorage');
  }
  const [user, setUser] = useState(initialUser);

  const login = (tokens) => {
    try {
      const { accessToken, refreshToken } = tokens;
      const decoded = jwtDecode(accessToken);
      localStorage.setItem('jwtToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken); // **STORE: refreshToken**

      setAuthHeaders(accessToken, decoded.tenantId); // **SET: Authorization Header**

      setUser({
        id: decoded.id,
        email: decoded.email,
        name: decoded.name,
        tenantId: decoded.tenantId, // **STORE: tenantId**
        token: accessToken,
      });
      setPendingNavigation('/app/dashboard');
    } catch (error) {
      console.error('AuthContext: Invalid token during login:', error);
    }
  };

  const logout = () => {
    const refreshToken = localStorage.getItem('refreshToken');
    if (refreshToken) {
      // Inform the backend to invalidate the refresh token
      api.post('/auth/logout', { refreshToken })
        .then(() => {
          console.log('Logged out from backend');
        })
        .catch((err) => {
          console.error('AuthContext: Error logging out from backend:', err);
        });
    }
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('refreshToken');
    setUser(null);
    setPendingNavigation('/');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, pendingNavigation, setPendingNavigation }}>
      {children}
    </AuthContext.Provider>
  );
};
